import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { logAnalyticsEvent } from '@/services/analytics'

import { getCityFromSlug } from '@/data/properties'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/properties',
    name: 'properties',
    alias: '/propiedades',
    component: () => import(/* webpackChunkName: "properties" */ '../views/PropertiesView.vue')
  },
  {
    path: '/propiedades/:citySlug',
    name: 'properties-city',
    alias: ['/properties/:citySlug', '/propiedades/en-:citySlug'],
    component: () => import(/* webpackChunkName: "properties" */ '../views/PropertiesView.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      const city = getCityFromSlug(to.params.citySlug)
      if (!city) {
        next({ name: 'not-found', replace: true })
      } else {
        next()
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFoundView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // Si navegamos entre la misma ruta solo cambiando queries (e.g. abriendo modal de detalle), no saltar arriba
    if (to.name === from.name && (to.name === 'properties' || to.name === 'properties-city')) {
      return false
    }
    return { top: 0 }
  }
})

router.afterEach((to) => {
  logAnalyticsEvent('page_view', {
    page_title: to.name || to.path,
    page_path: to.fullPath
  })
})

export default router
